// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd9b4779","337":"07edd5f4","453":"13885bd0","455":"3d478f8e"}[chunkId] + ".chunk.js";
};